/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leave_CommunityInputs */

const en_leave_community = /** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave Community`)
};

const es_leave_community = /** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonar Comunidad`)
};

const fr_leave_community = /** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter la communauté`)
};

const de_leave_community = /** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community verlassen`)
};

const id_leave_community = /** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan Komunitas`)
};

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const ja_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const zh_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const ar_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const it_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const ru_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const pt_leave_community = en_leave_community;

/** @type {(inputs: Leave_CommunityInputs) => LocalizedString} */
const ko_leave_community = en_leave_community;

/**
* | output |
* | --- |
* | "Leave Community" |
*
* @param {Leave_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const leave_community = /** @type {((inputs?: Leave_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leave_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leave_community(inputs)
	if (locale === "es") return es_leave_community(inputs)
	if (locale === "fr") return fr_leave_community(inputs)
	if (locale === "de") return de_leave_community(inputs)
	if (locale === "ja") return ja_leave_community(inputs)
	if (locale === "zh") return zh_leave_community(inputs)
	if (locale === "ar") return ar_leave_community(inputs)
	if (locale === "id") return id_leave_community(inputs)
	if (locale === "it") return it_leave_community(inputs)
	if (locale === "ru") return ru_leave_community(inputs)
	if (locale === "pt") return pt_leave_community(inputs)
	return ko_leave_community(inputs)
});